import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Box,
  Typography,
  Button,
  Card,
  CardMedia,
  CardContent,
  CircularProgress,
  Divider,
  Alert,
} from "@mui/material";
import { ArrowBack } from "@mui/icons-material";
import "../styles/SingleBlog.css";

const BLOGS_API = process.env.REACT_APP_BLOGS_API_URL;
const BASE_URL = process.env.REACT_APP_BASE_URL;

const SingleBlog = () => {
  const { slug } = useParams();
  const navigate = useNavigate();

  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('Slug from URL:', slug); // Debug log
    
    if (!slug || slug.trim() === '') {
      console.error('Empty slug received');
      setError('Invalid blog URL');
      setLoading(false);
      return;
    }
    
    fetchBlog();
    // eslint-disable-next-line
  }, [slug]);

  const fetchBlog = async () => {
    try {
      setLoading(true);
      setError(null);

      // Send the slug as-is to match PHP processing
      const apiUrl = `${BLOGS_API}?title=${encodeURIComponent(slug)}`;
      
      console.log('Fetching from:', apiUrl); // Debug log

      const res = await fetch(apiUrl);
      
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }

      const data = await res.json();
      
      console.log('API Response:', data); // Debug log

      if (data.success && data.blog) {
        console.log('Blog found:', data.blog); // Debug log
        setBlog(data.blog);
      } else {
        console.error('Blog not found:', data.message);
        setError(data.message || 'Blog not found');
      }
    } catch (error) {
      console.error("Fetch error:", error);
      setError('Failed to load blog. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <Box className="loading-container" sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        minHeight: '60vh' 
      }}>
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (error) {
    return (
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Alert severity="error" sx={{ mb: 3 }}>
          {error}
        </Alert>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate("/blogs")}
        >
          Back to Blogs
        </Button>
      </Container>
    );
  }

  if (!blog) {
    return (
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Box className="error-container" sx={{ textAlign: 'center', py: 8 }}>
          <Typography variant="h5" sx={{ mb: 3 }}>
            Blog not found
          </Typography>
          <Button
            variant="contained"
            startIcon={<ArrowBack />}
            onClick={() => navigate("/blogs")}
          >
            Back to Blogs
          </Button>
        </Box>
      </Container>
    );
  }

  return (
    <div className="single-blog-page">
      <Container maxWidth="lg" sx={{ py: 5 }}>
        <Button
          variant="contained"
          startIcon={<ArrowBack />}
          onClick={() => navigate("/blogs")}
          sx={{ mb: 3 }}
        >
          Back to Blogs
        </Button>

        <Card sx={{ overflow: 'hidden' }}>
          {blog.image && (
            <CardMedia
  component="img"
  image={`${BASE_URL}/uploads/${blog.image}`}
  alt={blog.title || "Blog image"}
  sx={{
    height: "300px",
    width: "100%",
    objectFit: "contain", // IMPORTANT
    backgroundColor: "#000",
  }}
/>

          )}

          <CardContent sx={{ p: 4 }}>
            <Typography variant="h3" component="h1" gutterBottom>
              {blog.title}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              Published on{" "}
              {new Date(blog.created_at).toLocaleDateString("en-US", {
                year: "numeric",
                month: "long",
                day: "numeric",
              })}
            </Typography>

            <Divider sx={{ my: 3 }} />

          <Typography
  component="div"
  sx={{
    whiteSpace: "pre-line",
    lineHeight: "1.8",
    fontSize: "18px",
    color: "black",
  }}
>
  {blog.document}
</Typography>


          </CardContent>
        </Card>
      </Container>
    </div>
  );
};

export default SingleBlog;